export enum MEDIA_TYPE {
  LINK = "LINK",
  PHOTO = "PHOTO",
  ANNOUNCE_REVIEW = "ANNOUNCE_REVIEW",
  ANNOUNCE_CONF = "ANNOUNCE_CONF",
}

export type MatchMedia = {
  description: string;
  hashTags: string[];
  id: number;
  leagueId: number;
  matchId: number;
  modifiedDate: string;
  title: string;
  typeLink?: string | null;
  gameFnlId?: string | null;
  vidId?: string | null;
  vidOid?: string | null;
  videoUrl?: string | null;
  url?: string | null;
  photos?: { url: string }[];
  type: MEDIA_TYPE;
};

export enum URL_TYPE {
  BROADCAST = "BROADCAST",
  LINK = "LINK",
}

export type MatchUrl = {
  id: number;
  typeLink: string;
  gameId: number;
  leagueId: number;
  url: string;
  modifiedDate: string;
  title: string;
  description: string;
  type: URL_TYPE;
};

export type MatchDescription = {
  id: number;
  title: string;
  description: string;
};

export type Match = {
  leagueId: number;
  matchId: number;
  fnlId?: number | string | null;
  seasonId: number;
  season: string;
  tourId: number;
  tour: string;
  date: string;
  stadium: {
    title?: string;
    city?: string;
    viewers?: string;
  };
  judges: {
    name?: string;
    city?: string;
  };
  home: {
    teamId: number;
    name: string;
    score: number;
  };
  guest: {
    teamId: number;
    name: string;
    score: number;
  };
  gambling?: null | string;
  urls: MatchUrl[];
  media: MatchMedia[];
  descriptions: MatchDescription[];
};

export type MatchesGrid = Match[];
